import React, { useEffect, useState }  from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Popup from "reactjs-popup";
//Header Config
import header_config from "./header_config";
import auth from '../../../service/Auth';
import { experiments_view, file_update, download_excel } from '../../../service/apis';
import { fetchHeadersList, fetchLocalExperimentsIDs, fetchExperiments } from './UtilFileSubmission';
import InformationDialog from "./components/InformationDialog"
import SubmissionHeader from "../components/SubmissionHeader"
import TableSubmit from '../components/TableSubmit';
import ErrorDialog from "../components/ErrorDialog";
import SubmissionDialog from "../submit-experiments/SubmissionDialog";
import { addRows, resetFormControls, hasErrors, getFilledRows, getNumbersErrors } from '../components/UtilSubmissionTable';
import { getAPIKey, validateForm, getTsvFileLoadingReport, parseSelectServerSide } from './UtilFileSubmission';

const config = window.config;


const SubmitFiles = (props) => {

    const [numberRows, setNumberRows] = useState(10);
    const [headers, setHeaders] = useState(header_config);
    const [formControls, setFormControls] = useState([
        [ 
            {id:"LocalExperimentID", index:0, value:'', error:'', valueIndex:null},
            {id:"Participant_ID", index:0, value:'', error:''},
            {id:"ExperimentID", index:0, value:'', error:''},
            {id:"File",index:0, value:[],error:''},
            {id:"FileName", index:0,value:'',error:''},{id:"FileType",index:0, value:'',error:''},
            {id:"CramRef", index:0,value:'',error:''},
            {id:"SequencingStrategy", index:0, value:'',error:''},{id:"ReadLength",index:0, value:'',error:''},
            {id:"InstrumentModel",index:0, value:'',error:''},{id:"SequencingCentre", index:0,value:'',error:''} 
        ],
    ]);
    const [group, setGroup] = useState({ value:"", selection: [],error:'' });
    const [redirect, setRedirect] = useState(false);
    const [redirectContents, setRedirectContents] = useState([[]]);
    const [popupErrors, setPopupErrors] = useState("");
    const [csvFileName, setCsvFileName] = useState("");
    const [tsvReport, setTsvReport] = useState({nonDefinedLocalIds: [], localIdsErrors: [], openInformationDialog: false});
    const [loadData, setLoadData] = useState(true);
    const [loadedChoiceList, setLoadedChoiceList] = useState(false);
    const [submission, setSubmission] = useState(false);
    const [validated, setValidated] = useState(false);

    
    const pushRows = nRows => {
        //Get current form control to later modify it
        let currentFormControls = [...formControls];
        //Add Rows
        addRows(nRows,currentFormControls, headers);
        //Update Form Control State
        setFormControls(currentFormControls);
        setNumberRows(currentFormControls.length);
    }
    
    const addRow = event => {
        const id = event.target.id;
        let nRows = parseInt(id.split("-")[1]);
        pushRows(nRows);
    }

    const resetStateForms = () => {
        // Reset all values
        const newFormControls = resetFormControls(formControls, headers);
        setFormControls(newFormControls);
    }
    
    const reload = event => { resetStateForms(); }
    
    // On load for the first time
    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setPopupErrors("Logging session timeout. Please log again");
        } else {
            // Get choice list through Rest API
            fetchHeadersList(headers,auth.getToken(),config.api_endpoint).then(
                result => {
                    pushRows(9);
                    setHeaders(result);  
                    setLoadedChoiceList(true);              
                }
            ); 
        }
    },[])

    useEffect(() => {
        if (loadedChoiceList) {
            if(typeof props.location.defaultContents !== "undefined")
            {
                let currentformControls = [...formControls];
                fetchLocalExperimentsIDs(auth.getToken(),config.api_endpoint,auth.getUserGroups()).then(
                    experiments => {
                        props.location.defaultContents.forEach((item, index) => { 
                            if (typeof currentformControls[index] === "undefined") addRows(1,currentformControls,headers);
                    
                            let rowControls = [...currentformControls[index]]; 
                            let lIDFieldControl = rowControls.find(item => { return item.id === "LocalExperimentID"});
                            let expItem = experiments.find(exp => { return exp.label === item["LocalExperimentID"]});
                            
                            lIDFieldControl.value = item["LocalExperimentID"];
                            lIDFieldControl.valueIndex = { value: expItem.index, label: item["LocalExperimentID"] };
                            let eIDFieldControl = rowControls.find(item => { return item.id === "ExperimentID"});
                            eIDFieldControl.value = item["ExperimentID"]
                            let pIDfieldControl = rowControls.find(item => { return item.id === "Participant_ID"}); 
                            pIDfieldControl.value = item["Participant_ID"];
                        });
                        setFormControls(currentformControls);
                        setLoadData(false);
                    }
                );
            } else {
                setLoadData(false);
            }
        } 
    },[loadedChoiceList])

    const loadExperiments = (search, loadedOptions, { page }) => {
        return fetchExperiments(auth.getToken(),config.api_endpoint, search, page); 
    }

    const validate = async (event) => {
        //Get current form control to later modify it
        let currentFormControls = [...formControls];
        //Validate Forms
        await validateForm(currentFormControls, headers);
        //Check Fastq File Names
        const valid_suffixes = [".fastq.gz",".fq.gz",".fastq.bz2",".fq.bz2",".bam",".cram"];
        let list_file_names = []
        for (let row of currentFormControls){
            for (let column of row){
                if (column.id === "FileName" && column.value !== ""){
                      let error_message = "";
                      //Check error suffix
                      let error_suffix = [];
                      let listItems = column.value.split(" ");
                      for (let item of listItems){
                          let error = false;
                          for (let suffix of valid_suffixes){
                              if (item.endsWith(suffix)) error = true;
                          }
                          error_suffix.push(error);
                          //Check Duplication Names
                          if (list_file_names.includes(item)) error_message = "File name already assigned. ";
                          else error_message = "";
                          list_file_names.push(item);
                      }
                      // Update Error
                      if (error_suffix.includes(false)) error_message = error_message + "File suffix not recognised. File must be one of the following compressed formats: .fastq.gz,.fq.gz,.fastq.bz2,.fq.bz2,.bam,.cram";
                      else error_message = error_message + "";
                      column.error = column.error + error_message;
                }
                //Do not allow a different file type according to the file name suffix
                if(column.id === "FileType"){
                    const fileName = row.find(item => item.id === "FileName");
                    if (fileName.value.endsWith(".bam")) {
                        if (column.value !== "BAM") {
                            column.error = "File Type must be BAM as file name has bam suffix";
                        }
                    }
                    else if (fileName.value.endsWith(".cram")) {
                        if (column.value !== "CRAM") {
                            column.error = "File Type must be CRAM as file name has cram suffix";
                        }
                    }
                    else if (fileName.value.endsWith(".gz") || fileName.value.endsWith(".bz2")) {
                        if (column.value !== "FASTQ") {
                            column.error = "File Type must be FASTQ as file name has FASTQ suffix";
                        }
                    }
                }
                //If file type is cram then Cram Reference must be selected
                if(column.id === "CramRef"){
                    const fileType = row.find(item => item.id === "FileType");
                    if (fileType.value === "CRAM" && ( column.value === "" || column.value === "----")){
                        column.error = "File Type is CRAM then a CRAM reference must be selected. If you do not find your fasta reference then please contact " + config.platform_mail;
                    }
                    else {
                        column.error = "";
                    }
                }
            }
        }
        //Update State
        setFormControls(currentFormControls);
        setValidated(true);
    }

    const submit = async (event) => {
        event.preventDefault();
        /*0. Validate*/
        /*0.1 Get current form control to later modify it */
        let currentFormControls = [...formControls];
        await validate();

        /*1. Check If Form Has Errors*/
        if (!hasErrors(currentFormControls)){
            /*2. Get fill Form Control*/
            const experimentRows = getFilledRows(currentFormControls, headers);
            /*2.1. Control api success */
            let data = []
            /*3. For Each Row Submit Experiment Info To Experiments API*/
            for (let row of experimentRows) {
                /*3.1. Generate data to send POST request*/
                let fileEntry = {};
                let commonMetadata = {};
                /*3.2. Collect all files for at Fill Column*/
                let list_file_names = [];
                for(let col of row){
                    if (col.id === "FileName"){
                        let files = col.value.split(" ");
                        list_file_names = [...files];
                    } else if (col.id === "CramRef"){
                        // Look for " - " and extract md5sum
                        let nPos = col.value.search(" - ")
                        let value = "";
                        // If " - " not founds it means no cram reference is selected
                        if (nPos === -1) value = '';
                        else value = col.value.split(" - ")[0];
                        commonMetadata[getAPIKey(col.id)] = value;
                    } else if (col.id !== "FileName"){
                        commonMetadata[getAPIKey(col.id)] = col.value;
                    }
                }
                /*3.3. Generate a dictionary per each File Declared*/
                for (let file_name of list_file_names){
                    fileEntry[file_name] = {...commonMetadata};
                    fileEntry[file_name]["file"] = file_name;
                    fileEntry[file_name]["file_name"] = file_name;
                    fileEntry[file_name]["library_name"] = "";
                    /*3.3.1 Add File Entry to data */
                    data.push(fileEntry[file_name]);
                }
            }
            /*4. Perform API POST Query*/
            /*4.1 Check Status*/
            setSubmission(true);
            const response = await file_update(auth.getToken(),config.api_endpoint,JSON.stringify(data));
            if (response.status !== 200) {    
                const error = await response.text();
                setPopupErrors(error);
                setSubmission(false);
            } 
            else {
                // 4.2 File succesfully created
                // 4.2.1 Error on file sibmission
                let tableContents = [];
                /* 4.2.2 Add Table Headers */
                let tableHeaders = [];
                for (let row of headers) {
                    tableHeaders.push(row.title);
                }
                tableContents.push(tableHeaders);
                /* 4.2.3 Add Table Values */
                for (let row of experimentRows){
                    let rowValues = [];
                    let fileList = [];
                    let index = 0;
                    let fileIndex,fileNameIndex = 0;
                    /* 4.2.4 Proces all columns from rows*/
                    for(let col of row){
                        if (col.id === "File"){
                            rowValues.push("")
                            fileIndex = index;
                        }
                        else if (col.id === "FileName"){
                            rowValues.push("");
                            let files = col.value.split(" ");
                            fileList = [...files];
                            fileNameIndex = index;
                        }
                        else {
                            rowValues.push(col.value);
                        }
                        index = index + 1;
                    }
                    /* 4.2.5 Unfold columns*/
                    for (let fileRow of fileList){
                        let insertRow = [...rowValues];
                        insertRow[fileIndex] = fileRow;
                        insertRow[fileNameIndex] = fileRow;
                        tableContents.push(insertRow);
                    }
                }
                /* 4.2.6 Go to Summary Inserted */
                let today = new Date().toISOString().slice(0, 10);
                setRedirectContents(tableContents);
                setCsvFileName(`${today}_submitted_files.csv`);
                setSubmission(false);
                setRedirect(true);
            }
        }
        else {
            //Update State
            setFormControls(currentFormControls);
            setSubmission(false);
        }
    };

    const changeHandler = event => {
        event.preventDefault();
        const name = event.target.name;
        const value = event.target.value;
        const id = name.split("-")[0];
        const index = name.split("-")[1];
        /*Call parent function*/
        let currentFormControls = [...formControls];
        let rowControls = [...currentFormControls[index]];
        let fieldControl = rowControls.find(item => { return item.id === id});
        /*Add File Value to File Name Input Box*/
        if (id === "File" && event.target.files.length > 0){
            /*1. Get List of File Names*/
            let files = [];
            for (let fileObject of event.target.files){
                files.push(fileObject.name)
            }
            /*2. Update state values for file and file name*/
            for (let column of rowControls){
                if (column.id === "FileName") column.value = files.join(" ");
                else if (column.id === "File") column.value = files;
            }
        } else if (Array.isArray(fieldControl.value)) {
            const indexField = fieldControl.value.indexOf(value);
            if (indexField === -1) fieldControl.value.push(value);
            else fieldControl.value.splice(indexField,1);
        } else {
            fieldControl.value = value;
        }
        /*3. Update State status*/
        let updateCurrentForm = formControls.map((item,j) => {
            if(j === index) return rowControls;
            else return item;
        });
        setFormControls(updateCurrentForm);
    }

    const changeSelectExperiment = async (newValue, actionMeta) => {
        /*on Change Handler for AsyncPaginate react Select Component used for Experiment Selection*/
        const id = actionMeta.name.split("-")[0];
        const index = actionMeta.name.split("-")[1];
        /*Update State With Selected Value*/
        let currentFormControls = [...formControls];
        let rowControls = currentFormControls[index];
        let fieldControl = rowControls.find(item => { return item.id === id});
        /*Update Value*/
        fieldControl.valueIndex = newValue;
        fieldControl.value = newValue.label;
        if (fieldControl.value === '----'){
            fieldControl.valueIndex = null;
            fieldControl.value = '';
            let experimentField = rowControls.find(item => { return item.id === "ExperimentID"});
            experimentField.value = "";
            let participantField = rowControls.find(item => { return item.id === "Participant_ID"});
            participantField.value = "";
        } else {
            /*Query EID and PID according to the new selected Local Experiment ID*/
            let dataQuery = {"page" : 1, "pageSize" : 100, 
                             "fields" : ["LocalExperimentID","ExperimentID","Participant_ID"],
                             "filtered":[{"id":"LocalExperimentID","value":[fieldControl.value]}, {"id":"file_submission_close","value": ["false"]}]}
            let doQuery = true;
            let position = parseInt(index);
            while (doQuery) {
                let response = await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(dataQuery));
                if (response.status === 200) {
                    let data = await response.json();
                    for (let experimentInfo of data["items"]) {
                        /*Update dependent fields ExperimentID and Participant_ID just if LocalId is exactly the searched one*/
                        if (experimentInfo["LocalExperimentID"] === fieldControl.value) {
                            let currentRow = currentFormControls[position];
                            let experimentField = currentRow.find(item => { return item.id === "ExperimentID"});
                            experimentField.value = experimentInfo["ExperimentID"];
                            let participantField = currentRow.find(item => { return item.id === "Participant_ID"});
                            participantField.value = experimentInfo["Participant_ID"];
                            if (position > index){
                                let localExpField = currentRow.find(item => { return item.id === "LocalExperimentID"});
                                localExpField.value = fieldControl.value;
                                localExpField.valueIndex = fieldControl.valueIndex;
                                currentFormControls.splice(position, 0, currentRow);
                            }
                            position = position + 1;
                        }
                    }
                    if (data["_meta"]["page"] < data["_meta"]["total_pages"]) {
                        dataQuery["page"] = dataQuery["page"] + 1;
                    } else {
                        doQuery = false;
                    }
                } else {
                    doQuery= false;
                }
            }
        }
        /*Update State*/
        setFormControls(currentFormControls);
        /*this.setState(state => {
            const formControls = state.formControls.map((item, j) => {
              if (j === index) {
                return rowControls;
              } else {
                return item;
              }
            });
            return {
              formControls,
            };
        });*/
    };

    const getExcel = async (event) => {
        //1. Get Table contents
        let contents = [];
        const keyHeaders = ["LocalExperimentID","Participant_ID","ExperimentID"];
        formControls.forEach(
          (row) => { 
              let localExperimentID = row.find(item => { return item.id === "LocalExperimentID"}); 
              if (localExperimentID.value != "")
              {
                  let values = [];
                  row.forEach(
                      (item) => {
                          if (keyHeaders.includes(item.id)) values.push(item.value);
                      }
                  );
                  contents.push(values);
              }   
          }
        );
        //2. Make Query
        const fields = headers.filter(x => x.id !== "File").map(x=>x.title);
        const mandatory = headers.filter(x => x.id !== "File" && x.mandatory).map(x=>x.title);
        const large_fields = ["RD-Connect ID Experiment"];
        const excel_name = "step2-files.xlsx";
        //2. Body Post
        const data = {
            fields : fields,
            mandatory : mandatory,
            large_fields : large_fields,
            contents: contents,
            excel_name : excel_name
        };
        //3. Call Download Excel API
        await download_excel(auth.getToken(),config.api_endpoint,JSON.stringify(data),excel_name);
    };

    const closeModal = () => { setPopupErrors(""); };

    const getPreloadedLocalIds = () => {
        let localIds = formControls.map((row) => { return row.find(item => item.id === "LocalExperimentID").value});
        return localIds.filter(value => value !== "");
    }

    const loadFile = async (data) => {
        let preloadedLocalIds = getPreloadedLocalIds();
        if(Array.isArray(data) && data[0].length>1){
            //Update Load Data to True
            setLoadData(true);
            //Reset Forms
            resetStateForms();
            //Get current form control to later modify it
            let currentFormControls = [...formControls];
            //Loop Over all Data
            let isFirst = true;
            let rowNumber = 0;
            let headerTitles = [];

            for (let row of data){
                //1. Avoid LogoutButton
                if(isFirst){
                    isFirst = false;
                    headerTitles = row;
                }
                else{
                    //Check if Form Controls has an array to fulfill it or not
                    if(rowNumber >= currentFormControls.length){
                        //Generate new item
                        addRows(1,currentFormControls,headers);
                    }
                    let colNumber = 0;
                    for (let column of row){
                        //Update value
                        let correctedColNumber = headers.findIndex(item => item.title === headerTitles[colNumber]);
                        let currentItem = currentFormControls[rowNumber][correctedColNumber];
                        let itemID = currentItem.id;
                        if (Array.isArray(currentItem.value)) {
                            currentItem.value.push(column);
                        }
                        else if(itemID === "LocalExperimentID")
                        {
                            // Call API Endpoint
                            if (column !== "") {
                                // Get Index on row for experiment and particpant ID
                                const expColNumber = headers.findIndex(item => item.id === "ExperimentID");
                                const partColNumber = headers.findIndex(item => item.id === "Participant_ID");
                                //Get Experiment and Particpant IDs state
                                let expID = currentFormControls[rowNumber].find(item => item.id === "ExperimentID");
                                let parID = currentFormControls[rowNumber].find(item => item.id === "Participant_ID");
                                if (row[expColNumber] !== "" && row[partColNumber] !== ""){
                                    //Update Submitter,Experiment and Particpant IDs state
                                    expID.value = row[expColNumber];
                                    parID.value = row[partColNumber];
                                    parseSelectServerSide([{"LocalExperimentID":column}],currentItem,"LocalExperimentID");
                                } else {
                                    let data_query = {"page" : 1, "pageSize" : 1, 
                                                      "fields" : ["LocalExperimentID","Participant_ID", "ExperimentID"],
                                                      "filtered":[{"id":"LocalExperimentID","value":[column]}]}
                                    const response =  await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
                                    const data = await response.json();
                                    parseSelectServerSide(data["items"],currentItem,"LocalExperimentID");
                                    //Submitter,Experiment and Particpant IDs state
                                    expID.value = data["items"][0]["ExperimentID"];
                                    parID.value = data["items"][0]["Participant_ID"];
                                }
                            }
                        }
                        else if(itemID !== "ExperimentID" && itemID !== "Participant_ID"){
                            currentItem.value = column;
                        }
                        colNumber ++;
                    }
                    rowNumber ++;
                }
            }

            //Validate File Inputs
            await validateForm(formControls, headers);
            const currentTsvReport = getTsvFileLoadingReport(preloadedLocalIds,formControls);
            //Update Form Control State
            setFormControls(currentFormControls);
            setNumberRows(currentFormControls.length);
            setTsvReport(currentTsvReport);
            setLoadData(false);
        }
        else{
           alert("File in wrong format. Please convert to Tab-Limited and upload again.")
        }
    }

    const closeInformationDialog = () => {
        setTsvReport({
            ...tsvReport,
            openInformationDialog: false
        });
    };

    /*Show popup in case an error with the api post occurs*/
    if (popupErrors) {
        return (
            <Popup open={true} closeOnDocumentClick onClose={closeModal}>
                <div>
                    <button className="close" onClick={closeModal}>  &times; </button>
                    <div className="page-header"> <h1> Error while generating new file entries. </h1> </div>
                    <div className="alert alert-warning">Error Reported: {popupErrors} </div>
                </div>
            </Popup>
        );
    }
   
    let nFormErrors = getNumbersErrors(formControls);

    //File Submission View
    return (
        <div className={"mainContent"}>
                {(redirect)
                    ? 
                        <SubmissionDialog
                            type={"Files"}
                            onClose={()=> setRedirect(false)} 
                            tableContents={redirectContents} 
                            tableFailContents={[]}
                            filename={csvFileName} 
                            open={redirect}
                        />
                    : null
                }
                {(validated )
                    ? <ErrorDialog  onClose={()=> setValidated(false)} errors={nFormErrors}/>
                    :  null}

                { /*Show Information Dialog if needed*/}
                <InformationDialog tsvReport={tsvReport} onClose={closeInformationDialog}/>
             
                <SubmissionHeader title={"Upload file/s metadata"} goBackHref={"#/selectexperiments"}
                                  addRow={addRow} validate={validate} 
                                  submit={submit} reload={reload} 
                                  loadFile={loadFile} getExcel={getExcel} />

                { submission  ? 
                    <Box sx={{ width: '100%' }}>
                        <Typography variant="body1">Updating database...</Typography>
                        <LinearProgress />
                    </Box>
                :  
                    <TableSubmit headers={headers} contents={formControls} changeHandler={changeHandler}
                                 loadExperiments={loadExperiments} changeSelectExperiment={changeSelectExperiment} loading={loadData} />
                        
                }                             
        </div>       
    );
}

export default SubmitFiles;
